// getRecommendedApplications

import BaseService from "./BaseService";
import { PagerParams } from "./utils";
import AppRuntimeEnv from "@/types/AppRuntimeEnv";
import { AuthData } from "@/types/LocalConfig";
import { FocusSDK, xClientMap } from "@/utils";
import { Method, pwaAttribute } from "@/attributes/pwaAttribute";
import ListThirdAppControllers from "@/components/ThirdApp/components/controllers/ListThirdAppControllers";
import ListCardController from "@/components/ThirdApp/components/controllers/ListCardController";
import { gatewayInstance } from "@/server/gateway";

// 应用类型
export enum OpenApiType {
  Inner = 1, // 内部应用
  Outer = 2 // 外部应用
}

export enum WebviewKernel {
  WebBrowser = 5,
  MainWindow = 6,
  NewWindow = 7
}

export enum TopType {
  TopNo = 0, // 不置顶
  TopYes = 1 // 置顶
}

export enum FavoriteType {
  FavoriteNo = 0, // 不是常用
  FavoriteYes = 1 // 常用
}

export enum RecommendedType {
  RecommendedNo = 0, // 不是推荐
  RecommendedYes = 1 // 推荐
}
export const RecommendedTypeTitle = {
  [RecommendedType.RecommendedNo]: "非推荐", // 不是推荐
  [RecommendedType.RecommendedYes]: "推荐" // 推荐
};
export enum StatusLabels {
  VPN = 0,
  INTERNET = 1,
  EGOV = 2,
  BETA = 3,
  UNDER_MAINTENANCE = 4,
  CORE = 5,
  BASIC = 6,
  ACCESS = 7,
  ONLY_MOBILE = 8
}
export const StatusLabelsText: any = {
  [StatusLabels.VPN]: "vpn",
  [StatusLabels.INTERNET]: "互联网",
  [StatusLabels.EGOV]: "政务外网",
  [StatusLabels.BETA]: "测试版",
  [StatusLabels.UNDER_MAINTENANCE]: "维护中",
  [StatusLabels.CORE]: "核心",
  [StatusLabels.BASIC]: "基础",
  [StatusLabels.ACCESS]: "接入",
  [StatusLabels.ONLY_MOBILE]: "移动端"
};

export const StatusLabelsStyles: any = {
  [StatusLabels.BETA]: {
    backgroundColor: "#005AF5",
    color: "#fff"
  },
  [StatusLabels.UNDER_MAINTENANCE]: {
    backgroundColor: "#FF6E6E",
    color: "#fff"
  },
  [StatusLabels.ONLY_MOBILE]: {
    backgroundColor: "#B0B0B0",
    color: "#fff"
  },
  default: {
    backgroundColor: "#FF923B",
    color: "#fff"
  }
};

export enum SupportTerminal {
  WEB = 0,
  IOS = 1,
  ANDROID = 2,
  IPAD = 3,
  WINDOWS = 4,
  MAC = 5,
  IMAC = 6,
  WEB_EGOV = 7,
  LINUX = 8,
  APAD = 9,
  H5 = 10
}

export const SupportTerminalText = {
  [SupportTerminal.WEB]: "web",
  [SupportTerminal.IOS]: "ios",
  [SupportTerminal.ANDROID]: "android",
  [SupportTerminal.IPAD]: "ipad",
  [SupportTerminal.WINDOWS]: "windows",
  [SupportTerminal.MAC]: "mac",
  [SupportTerminal.IMAC]: "imac",
  [SupportTerminal.WEB_EGOV]: "浏览器",
  [SupportTerminal.LINUX]: "linux",
  [SupportTerminal.APAD]: "apad",
  [SupportTerminal.H5]: "浏览器"
};

export interface AppStoreApplication {
  applicationId: string;
  applicationKey: string;
  applicationSecret: string;
  developmentType: number;
  openApiType: OpenApiType;
  name: string;
  appName?: string;
  icon: string;
  appIcon?: string;
  maxVersion: string;
  minVersion: string;
  mobileHomeUrl: string;
  pcHomeUrl: string;
  homeUrl: string;
  iosWebviewKernel: string;
  androidWebviewKernel: string;
  padosWebviewKernel: string;
  nativeIdentifier: string;
  webviewKernel: WebviewKernel; // web_browser:5, mainWindow:6, newWindow:7
  brief: string;
  description?: string;
  developer: string;
  builder?: string;
  favorite: FavoriteType;
  recommended: RecommendedType;
  applicationStatusLabels: any;
  networkEnvLabels: any;
  supportMode?: boolean;
  needAuth?: boolean;
  authorize?: boolean;
  topType?: TopType;
  emitCallback?: any;
  iconfont?: string;
  disabled?: boolean;
  sceneType?: number;
  uuid?: string;

  // androidWebviewKernel: 2
  // applicationId: "SlCoVtwaeM7yXTIpEWpd"
  // applicationKey: "dnADq9PvlSnhurxaUayM"
  // applicationSecret: null
  // developmentType: 1
  // icon: "http://storage.jd.com/jd.jme.file.cache/OA.png"
  // iosWebviewKernel: 2
  // maxVersion: "999.999.999.999"
  // minVersion: "000.000.000.000"
  // mobileHomeUrl: "https://moa.jdcloud.com"
  // name: "审批"
  // nativeIdentifier: null
  // openApiType: 1
  // padosWebviewKernel: 2
  // pcHomeUrl: "https://moa.jdcloud.com"
}

export interface AppStoreGroupApplication {
  groupId: string;
  name: string;
  version: string;

  applications: AppStoreApplication[];
}

export interface AppStoreGroupScenesApplication {
  groupId: string;
  name: string;
  version: string;

  applicationScenes: AppStoreApplication[];
}

export interface AppStoreRecommendRes {
  groupApplication: AppStoreGroupApplication;
}

export interface AppStoreGroupRes {
  groupApplications: AppStoreGroupApplication[];
}

// 工作台应用场景
export interface AppStoreGroupScenesRes {
  groupApplicationScenes: AppStoreGroupScenesApplication[];
}

export interface IAppStoreScenesReq {
  sceneType?: number;
  version?: string;
  groupApplicationVersions?: {
    version?: string;
  }[];
}

export interface AuthCodeRes {
  code: string;
}

export interface batchExchangeOpenUserInfo {
  appKey: string;
  openUserTeamIds: {
    openUserId: string;
    openTeamId: string;
  }[];
}

export interface batchExchangeUserInfo {
  appKey: string;
  userTeamIds: {
    userId: string;
    teamId: string;
  }[];
}

class AppStoreService extends BaseService {
  // appKey: string;

  // constructor(appRuntime: AppRuntimeEnv, focusSDK: IFocusSDK) {
  //     super(appRuntime, focusSDK);
  //     // this.appKey = appRuntime.config.app.appStoreAppKey;
  // }
  @pwaAttribute(
    Method.post,
    ListThirdAppControllers,
    "getGroupApplications",
    "setGroupApplications",
    "lists",
    "specialOnlineMethod"
  )
  getGroupApplications(
    params: {
      userId: string;
      teamId: string;
      groupApplicationVersions?: any;
      version?: string;
    } & PagerParams
  ) {
    // FocusSDK.printLog("getGroupApplications api", params);
    const platform = FocusSDK?.getDeviceInfo()?.platform;
    const xClient = xClientMap[platform];
    return gatewayInstance.request<AppStoreGroupRes>({
      api: "appstore.getGroupApplications",
      method: "POST",
      body: params,
      headers: {
        "application-x-client": xClient
      }
    });
    // return this.fetch<AppStoreGroupRes>('appstore', 'getGroupApplications', {
    //     // appKey: this.appKey,
    //     // indexName: 'global',
    //     // lang: 'zh_CN',
    //     // client: getClientType(),
    //     // version: '1.0.0',
    //     ...params,
    // });
  }
  // 按场景获取应用
  getGroupApplicationScenes(params: IAppStoreScenesReq) {
    return gatewayInstance.request<AppStoreGroupScenesRes>({
      api: "appstore.getGroupApplicationScenes",
      method: "POST",
      body: params
    });
  }

  getFavoriteApplications(
    params: {
      userId: string;
      teamId: string;
    } & PagerParams
  ) {
    FocusSDK.printLog("getFavoriteApplications api", params);
    return this.fetch<AppStoreGroupApplication>("appstore", "getFavoriteApplications", {
      // appKey: this.appKey,
      // indexName: 'global',
      // lang: 'zh_CN',
      // client: getClientType(),
      // version: '1.0.0',
      ...params
    });
  }
  // 应用角标
  getAppMsgCount(params: any) {
    return this.fetch("appstore", "getUserBadges", {
      ...params
    });
  }

  checkApplicationNeedAuth(
    params: {
      userId: string;
      teamId: string;
      mode: string;
      appKey: string;
    } & PagerParams
  ) {
    return this.fetch<AppStoreApplication>("eopen", "checkAppAuth", {
      // appKey: this.appKey,
      // indexName: 'global',
      // lang: 'zh_CN',
      // client: getClientType(),
      // version: '1.0.0',
      ...params
    });
  }

  submitApplicationAuth(
    params: {
      userId: string;
      teamId: string;
      mode: string;
      appKey: string;
      authorize: boolean;
    } & PagerParams
  ) {
    return this.fetch<AppStoreApplication>("eopen", "submitAppAuth", {
      // appKey: this.appKey,
      // indexName: 'global',
      // lang: 'zh_CN',
      // client: getClientType(),
      // version: '1.0.0',
      ...params
    });
  }

  getRecommendedApplications(
    params: {
      userId: string;
      teamId: string;
    } & PagerParams
  ) {
    FocusSDK.printLog("getRecommendedApplications api", params);
    return this.fetch<AppStoreRecommendRes>("appstore", "getRecommendedApplications", {
      // appKey: this.appKey,
      // indexName: 'global',
      // lang: 'zh_CN',
      // client: 'IOS', // getClientType(),
      // version: '1.0.0',
      ...params
    });
  }

  getAuthCode(appKey: string) {
    return this.fetch<AuthCodeRes>("focus", "getOpenPlatformCode", {
      appKey
    });
  }
  removeFavoriteApplication(
    params: {
      // appKey: string;
      userId: string;
      teamId: string;
      applicationId: string;
    } & PagerParams
  ) {
    FocusSDK.printLog("removeFavoriteApplication api", params);
    return this.fetch<boolean>("appstore", "removeFavoriteApplication", {
      ...params
    });
  }

  addFavoriteApplication(
    params: {
      // appKey: string;
      userId: string;
      teamId: string;
      applicationId: string;
    } & PagerParams
  ) {
    FocusSDK.printLog("addFavoriteApplication api", params);
    return this.fetch<boolean>("appstore", "addFavoriteApplication", {
      ...params
    });
  }

  // 批量编辑
  editFavoriteApplication(
    params: {
      // appKey: string;
      userId: string;
      teamId: string;
      applicationIds: [];
    } & PagerParams
  ) {
    FocusSDK.printLog("editFavoriteApplication api", params);
    return this.fetch<boolean>("appstore", "editFavoriteApplication", {
      ...params
    });
  }

  verifyUserToken(params: { userAccessToken: string }) {
    return this.fetch<any>("eopen", "verifyUserToken", {
      ...params
    });
  }

  batchExchangeUser(params: batchExchangeOpenUserInfo) {
    return this.fetch<batchExchangeUserInfo>("eopen", "batchExchangeUser", {
      ...params
    });
  }

  batchExchangeOpenUser(params: batchExchangeUserInfo) {
    return this.fetch<batchExchangeOpenUserInfo>("eopen", "batchExchangeOpenUser", {
      ...params
    });
  }

  getApplication(params: { applicationKey: string }) {
    return gatewayInstance.request({
      api: "appstore.getApplication",
      method: "POST",
      body: params
    });
  }

  // 获取卡片
  @pwaAttribute(Method.post, ListCardController, "getCards", "setCards", "cards")
  getCards(params: any) {
    return gatewayInstance.request<AppStoreGroupRes>({
      api: "appstore.getCards",
      method: "POST",
      body: params
    });
  }
  // 更新已添加的卡片
  updateCards(params: any) {
    return gatewayInstance.request<AppStoreGroupRes>({
      api: "appstore.updateCards",
      method: "POST",
      body: params
    });
  }

  /**
   * 工作台查询最近三个月的新增应用
   */
  getApplicationCountAndList(params: any) {
    return gatewayInstance.request<any>({
      api: "appstore.queryApplicationCountAndList",
      method: "GET",
      body: params
    });
  }

  /**
   * 工作台查询最近几个月的应用数折线图
   */
  getMonthApplicationCountList(params: any) {
    return gatewayInstance.request<any>({
      api: "appstore.queryMonthApplicationCountList",
      method: "GET",
      body: params
    });
  }
}

export default AppStoreService;
